export enum ShoppingCartTabs {
  BuildCart = 0,
  OrderDetails = 1,
  ConfirmOrder = 2,
  OrderInProcess = 3
}
